<template>
    <header class="header">
        <nav class="main_menu navbar navbar-expand-lg navbar-light fixed-top">
          <div class="container">
            <a class="navbar-brand" href="/">
              <img class="img-fluid" src="/images/png/logo_white.png" alt="" />
            </a>
            <button
              class="navbar-toggler menu"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <div></div>
              <div></div>
              <div></div>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul  id="menu-main-menu" class="navbar-nav navbar-nav-navs me-auto ms-auto mb-2 mb-lg-0 align-items-center">
                <li class="nav-item">
                  <a class="nav-link">
                    <router-link class-active="active" to="./">Anasayfa</router-link></a>
                </li>
                <li class="nav-item dropdown dropdown_hover">
                  <a class="nav-link">
                    <router-link class-active="active" to="/kampanyalar">Kampanyalar</router-link>
                  </a>
                  <ul class="dropdown-menu showOnMobile">
                    <li><a class="dropdown-item"><router-link class-active="active" to="/kampanyalar">Aktif Kampanyalar</router-link></a></li>                    <li><a class="dropdown-item"><router-link class-active="active" to="/biten-kampanyalar">Biten Kampanyalar</router-link></a></li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link"><a href="https://kampanya.cekkazan.com.tr/" target="_blank" rel="noopener noreferrer" class="active">Web'den Katıl</a></a>
                </li>
                <li class="nav-item">
                  <a class="nav-link"><router-link class-active="active" to="/duyurular">Duyurular</router-link></a>
                </li>
                <li class="nav-item dropdown dropdown_hover">
                  <a class="nav-link">
                    <router-link class-active="active" to="/sikca-sorulan-sorular">Sıkça Sorulan Sorular</router-link>
                  </a>
                   <ul class="dropdown-menu showOnMobile" aria-labelledby="navbarDropdown">
                    <li>
                      <a class="dropdown-item"><router-link class-active="active" to="/sikca-sorulan-sorular/nasil-kazanirim">Nasıl Kazanırım?</router-link></a>
                    </li>
                  </ul>
                </li>
                <li class="nav-item mt-3 mt-lg-0">
                  <a href="https://cekkazan.com.tr/kurumsal/index.html" type="button" >
                      <span>
                          <img style="vertical-align:middle" src="/images/png/justsnap.webp">
                      </span>
                  </a>
                </li>
              </ul>
              <nav class="mobile_menu">
                <ul id="menu-main-menu-1" class="navbar-nav navbar-nav-navs me-auto ms-auto mb-2 mb-lg-0 align-items-center">
                    <li id="mobile-menu-item-165" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home ">
                        <a ><router-link class-active="active" to="/">
                            Anasayfa
                          </router-link>
                        </a>
                        <span class="mobile_arrow"><i class="fa fa-angle-right"></i><i class="fa fa-angle-down"></i></span>
                    </li>
                    <li id="mobile-menu-item-492" class=" menu-item menu-item-type-post_type menu-item-object-page current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children has_sub">
                        <a>
                          <router-link class-active="active" to="/kampanyalar">
                            Kampanyalar
                          </router-link>
                        </a>
                        <ul class="sub_menu">
                            <li  class=" ">
                              <a class="dropdown-item">
                                <router-link class-active="active" to="/biten-kampanyalar">
                                  Biten Kampanyalar
                                </router-link>
                              </a>
                            </li>
                        </ul>
                        <ul class="sub_menu">
                            <li  class=" ">
                              <a class="dropdown-item">
                                <a href="https://kampanya.cekkazan.com.tr/" target="_blank" rel="noopener noreferrer" class="active">
                                  Web'den Katıl
                                </a>
                              </a>
                            </li>
                        </ul>
                      </li>
                      <li id="mobile-menu-item-7222" class="menu-item menu-item-type-post_type menu-item-object-page ">
                          <a class="">
                            <router-link class-active="active" to="/duyurular">
                              Duyurular
                            </router-link>
                          </a>
                          <span class="mobile_arrow"><i class="fa fa-angle-right"></i><i class="fa fa-angle-down"></i></span>
                      </li>
                      <li id="mobile-menu-item-234" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children  has_sub">
                          <a>
                            <router-link class-active="active" to="/sikca-sorulan-sorular">
                              Sıkça Sorulan Sorular
                            </router-link>
                          </a>
                          <span class="mobile_arrow"><i class="fa fa-angle-right"></i><i class="fa fa-angle-down"></i></span>
                          <ul class="sub_menu">
                              <li id="mobile-menu-item-7764" class="menu-item menu-item-type-post_type menu-item-object-page ">
                                <a>
                                  <router-link class-active="active" to="/sikca-sorulan-sorular/nasil-kazanirim">
                                    Nasıl Kazanırım?
                                  </router-link>
                                </a>
                                <span class="mobile_arrow"><i class="fa fa-angle-right"></i><i class="fa fa-angle-down"></i></span>
                              </li>
                          </ul>
                      </li>
                      <li id="mobile-menu-item-5832" class="menu-item menu-item-type-custom menu-item-object-custom ">
                          <a href="https://cekkazan.com.tr/kurumsal/index.html" class="">
                              <span><img style="vertical-align:middle" src="/images/png/justsnap.webp"></span>
                          </a>
                          <span class="mobile_arrow"><i class="fa fa-angle-right"></i><i class="fa fa-angle-down"></i></span>
                      </li>
                  </ul>
              </nav>
              <form class="d-block d-lg-flex forms align-items-center">
                <div class="wrapper_social_btn">
                  <a href="https://www.facebook.com/cekkazan/" class="social_btn"><i class="lab la-facebook-f"></i></a>
                  <a href="https://www.instagram.com/cekkazan/" class="social_btn"><i class="lab la-instagram"></i></a>
                  <a href="https://www.youtube.com/cekkazan" class="social_btn"><i class="lab la-youtube"></i></a>
                </div>
              </form>
            </div>
          </div>
        </nav>
    </header>
</template>
<script>
export default {
  name: 'GlobalHead'
}
</script>